// extracted by mini-css-extract-plugin
export default {"imageWrapper":"hG-z","hovered":"iG-z","hoverImage":"jG-z","mainImage":"kG-z","imageNoBackground":"lG-z","fullSizeImage":"mG-z"};